import { useContext } from 'react'

import { WorkspacePermissionsContext } from 'src/context/WorkspacePermissionsContext'

/**
 * Raw access to the effective workspace permissions. Prefer
 * `useHasWorkspacePermissions` / `useHasAnyWorkspacePermission` for checks —
 * read this directly only when you need `isLoading` to tell "still resolving"
 * apart from "denied".
 */
export const useWorkspacePermissionsContext = () =>
  useContext(WorkspacePermissionsContext)
